import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import RequiredLabel from '../RequiredLabel/RequiredLabel';

const ValidatedDropdown = (props) => {
    return (
      <Field name={props.name}>
          {({ input, meta }) => (
            <div className={(meta.submitError || meta.error && meta.touched) ? 'form-group has-danger col-sm-'+props.cols : !meta.error && meta.touched ? 'form-group has-success col-sm-'+props.cols : 'form-group col-sm-'+props.cols}>
              <RequiredLabel>{props.label}</RequiredLabel>{(meta.submitError || meta.error && meta.touched) && <div className="invalid-feedback" style={{display:'block'}}>{meta.error ? meta.error : meta.submitError}</div>}
               <select {...input} tabIndex={props.tabIndex || 0} className="form-control" className={(meta.submitError || meta.error && meta.touched) ? 'form-control is-invalid' : !meta.error && meta.touched && !meta.submitError ? 'form-control is-valid' : 'form-control'} placeholder={props.placeholder}>
                 {props.values.map(p=><option key={p.Key} value={p.Key}>{p.Value}</option>)}
                </select>
            </div>
          )}
      </Field>
    );
  };
  
export default ValidatedDropdown;
  